import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class StatisticsApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.STATISTICS);
  }

  getProcessingOrderCount() {
    return this.httpClient.get(
      `${this.getResourceUrl()}processing-order-count/`,
    );
  }
}

export default new StatisticsApi();
